import { LocalDate } from '@js-joda/core';

import { createTranslatedText, dateFormatter } from '@dreryk/react-common';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { PrescriptionTextValue } from '../PrescriptionTextValue';

type IssuedToTextViewProps = {
   readonly issuedTo: LocalDate;
};

export const IssuedToTextView = (props: IssuedToTextViewProps): JSX.Element => {
   return (
      <PrescriptionTextValue
         testId={'issuedTo'}
         label={prescriptionTranslationKeys.issueDate.issuedTo}
         value={createTranslatedText(dateFormatter(props.issuedTo))}
      />
   );
};
